import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { useSpotlight } from '../hooks/useSpotlight';
import { useI18n } from '../i18n/I18nContext';

interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  link?: string;
  animationDirection?: 'left' | 'right';
}

function ServiceCard({ icon, title, description, link, animationDirection = 'left' }: ServiceCardProps) {
  const { t } = useI18n();
  const [isVisible, setIsVisible] = useState(false);

  const ref = useIntersectionObserver({
    onIntersect: () => setIsVisible(true),
    threshold: 0.05,
    rootMargin: '0px 0px -20px 0px',
  });
  const handleSpotlight = useSpotlight<HTMLDivElement>();

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      onPointerMove={handleSpotlight}
      className={`spotlight-card bg-zinc-900 p-8 rounded-lg shadow-lg hover:shadow-xl hover:border-[#FDCB12]/70 border border-zinc-800 transform hover:-translate-y-1 transition-all duration-700 ease-out ${
        isVisible ? 'opacity-100 translate-x-0 translate-y-0' : `opacity-0 translate-y-6 ${animationDirection === 'left' ? '-translate-x-2' : 'translate-x-2'}`
      }`}
    >
      <div className="motion-icon text-[#FF5500] mb-4">{icon}</div>
      <h3 className="text-xl font-bold mb-3 text-white">{title}</h3>
      <p className="text-gray-400 mb-4">{description}</p>
      {link && (
        <Link
          to={link}
          className="text-[#FF5500] font-medium flex items-center hover:text-[#FDCB12] transition-all duration-300 group"
        >
          {t.hero.learnMore} <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </Link>
      )}
    </div>
  );
}

export default ServiceCard;
